export default "__VITE_ASSET__03dc69d0__"